import styled from "styled-components";

export const TituloPrimario = styled.h1`
  text-transform: uppercase;
  max-width: 40rem;
  font-weight: 300;
  font-size: 2.8rem;
  line-height: 1.4;
`;
